'use strict';
var createReactClass = require('create-react-class');

/**
 * returns unescaped html
 *
 * @author smollweide
 * @method UnescapedHtml
 *
 * <UnescapedHtml markup="<strong>Hallo</strong>" />
 *
 */
module.exports =  createReactClass({

	displayName: 'UnescapedHtml',

	render: function () {
		return (<span dangerouslySetInnerHTML={{__html: this.props.markup}} />);
	}

});



// WEBPACK FOOTER //
// ./src/components/utils/helper/helper-unescaped-html.jsx